<template>
  <a href="#" v-bind="$attrs"><i class="fa5 fas" :class="icon"></i></a>
</template>

<script>

export const PublishStatus = Object.freeze({
  PUBLISHED: 'published',
  NOT_PUBLISHED: 'not-published',
  SOME_PUBLISHED: 'some-published',
});

export default {
  name: 'i-publish-status-indicator',
  props: {
    status: {
      type: String,
      validator: (value) => Object.values(PublishStatus).includes(value),
      default: PublishStatus.NOT_PUBLISHED,
    },
  },
  computed: {
    icon() {
      return {
        [PublishStatus.PUBLISHED]: 'fa-check-square',
        [PublishStatus.NOT_PUBLISHED]: 'fa-square',
        [PublishStatus.SOME_PUBLISHED]: 'fa-minus-square',
      }[this.status];
    },
  },
};
</script>

<style scoped lang='scss'>
.fa-check-square, .fa-minus-square {
  color:#26BF4B;
}
.fa-square {
  color: $gray;
}
</style>
